/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ language: NonNullable<unknown> }} Recipe_Translated_FromInputs */

const en_recipe_translated_from = /** @type {(inputs: Recipe_Translated_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Translated from ${i?.language}.`)
};

const de_recipe_translated_from = /** @type {(inputs: Recipe_Translated_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aus dem ${i?.language} übersetzt.`)
};

/**
* | output |
* | --- |
* | "Translated from {language}." |
*
* @param {Recipe_Translated_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_translated_from = /** @type {((inputs: Recipe_Translated_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Translated_FromInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_translated_from(inputs)
	return en_recipe_translated_from(inputs)
});